import { render } from "./SmallWidget.vue?vue&type=template&id=d55f3060&scoped=true"
import script from "./SmallWidget.vue?vue&type=script&lang=js"
export * from "./SmallWidget.vue?vue&type=script&lang=js"

import "./SmallWidget.vue?vue&type=style&index=0&id=d55f3060&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d55f3060"]])

export default __exports__